// Qué se baja entero y qué no — ADR-2026-11-03-bajar-solo-lo-que-se-ve.
//
// Cada clip tiene su `<video>`/`<audio>` montado, y antes todos iban con
// `preload="auto"`: al abrir un proyecto el navegador bajaba TODOS los archivos
// enteros y a la vez (el más pesado de estos días: 11 videos, 144 MB). El clip que
// se mira peleaba ancho de banda con todos los demás. Ahora se baja entero sólo lo
// que está cerca del cursor; el resto trae sólo la metadata (duración, tamaño),
// y si alguien salta hasta ahí, el seek pide el pedazo que haga falta.

/** Cuánto por delante del cursor se empieza a bajar un clip. */
export const VENTANA_ADELANTE_S = 12;
/** Cuánto por detrás se lo sigue teniendo (volver un poco atrás no espera). */
export const VENTANA_ATRAS_S = 2;

export function precargaDelClip(
  clip: { startTime: number; duration: number },
  tiempo: number,
): 'auto' | 'metadata' {
  const fin = clip.startTime + clip.duration;
  const cerca =
    clip.startTime <= tiempo + VENTANA_ADELANTE_S && fin >= tiempo - VENTANA_ATRAS_S;
  return cerca ? 'auto' : 'metadata';
}
